const FromArr = [
  {
    title: "",
    modelvalue: "",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    types: "text",
    placeholder: "请输入内容",
    width: 234,
    height: 32,
    
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
    X: false,
  },
  {
    title: "",
    inputtype: "date",
    inputflag: true,
    fontSize: 14,
    color: "#424E66",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    width: 234,
    disabled: false,
    marginLeft: 25,
    marginTop: 30,
  },
];
export default FromArr;
